import { Typography } from '@mui/material';

import { Dot } from '@/uiKit/atoms/Dot';

export const TabIcon = ({
  selected,
  count,
}: {
  selected: boolean;
  count: number;
}) => {
  return (
    <Dot
      color={selected ? 'blackAndWhite' : 'orange'}
      content={<Typography variant="bodySmall">{count}</Typography>}
    />
  );
};
